import styled, { css } from 'styled-components';
import Text from '@components/text';
import Image from '@components/image';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 4rem;
    align-items: center;
    width: 100%;
    max-width: 48rem;
    align-self: center;
    margin: 0 auto;
    border-radius: ${theme.borderRadius.large};

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      row-gap: 3.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
    }
  `}
`;

export const HeadingWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const PinImageWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%) translateX(calc(-50% + 0.75rem - 4.5rem));
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      width: 3rem;
      height: 3rem;
      transform: translateY(-50%) translateX(calc(-50% + 0.75rem - 3rem));
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: 3rem;
      height: 3rem;
      transform: translateY(-50%) translateX(calc(-50% + 0.625rem - 3rem));
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      width: 2rem;
      height: 2rem;
      transform: translateY(-50%) translateX(calc(-50% + 0.5rem - 2rem));
    }
  `}
`;

export const PinImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const StyledTextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    text-align: left;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      gap: 0.5rem;
    }
  `}
`;

export const StyledGrid = styled.div`
  display: grid;
  gap: 0rem;
  width: 100%;
  grid-template-columns: repeat(1, 1fr);
`;

export const FeatureDescription = styled(Text)`
  ${({ theme }) => css`
    line-height: ${theme.lineHeights.lg};
  `}
`;

export const StyledBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 2rem 0 2rem 4.5rem;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border-left: 0.625rem solid ${theme.colors.primary};
      border-right: 0.625rem solid ${theme.colors.primary};
      width: 1.5rem;
      height: 100%;
      background: ${theme.colors.white};
    }

    &:first-child {
      &::before {
        border-top: 0.625rem solid ${theme.colors.primary};
        border-radius: 0.625rem 0.625rem 0 0;
      }
    }

    &:last-child {
      &::before {
        border-bottom: 0.625rem solid ${theme.colors.primary};
        border-radius: 0 0 0.625rem 0.625rem;
      }
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      padding: 2rem 0 2rem 5.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 2rem 0 2rem 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 2rem 0 2rem 3rem;

      &::before {
        border-left: 0.5rem solid ${theme.colors.primary};
        border-right: 0.5rem solid ${theme.colors.primary};
        width: 1.25rem;
      }

      &:first-child {
        &::before {
          border-top: 0.5rem solid ${theme.colors.primary};
          border-radius: 0.5rem 0.5rem 0 0;
        }
      }

      &:last-child {
        &::before {
          border-bottom: 0.5rem solid ${theme.colors.primary};
          border-radius: 0 0 0.5rem 0.5rem;
        }
      }
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 2rem 0 2rem 2rem;

      &::before {
        border-left: 0.375rem solid ${theme.colors.primary};
        border-right: 0.375rem solid ${theme.colors.primary};
        width: 1rem;
      }
    }
  `}
`;
